export default "__VITE_ASSET__CvkyJb3J__"